import { useQuery } from '@tanstack/react-query';
import { createHttpService } from '../../../../apis/ApiService';

export interface RbacRole {
  id: string;
  name: string;
  description?: string;
  instituteId: string;
  isDefault: boolean;
}

const STAFF_ELIGIBLE_ROLES = ['internal_staff', 'admin_role', 'teacher', 'external_staff'];
const ROLES_QUERY_KEY = 'rbac-roles-staff-eligible';

export const useStaffEligibleRoles = (enabled = true) => {
  const httpAPI = createHttpService();

  return useQuery<RbacRole[]>({
    queryKey: [ROLES_QUERY_KEY],
    queryFn: async () => {
      const res = await httpAPI.rbac.get<RbacRole[]>('/roles');
      const roles = Array.isArray(res) ? res : (res as any)?.data ?? [];
      return roles.filter((role: RbacRole) =>
        STAFF_ELIGIBLE_ROLES.includes(role.name)
      );
    },
    enabled,
  });
};
